import React, { useEffect, useRef, useState } from 'react';
import { Backdrop, Box, CircularProgress, IconButton } from '@mui/material';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import { isMobile } from 'react-device-detect';

const VideoPlayer = ({
  videoUrl,
  isChallengePage = false,
  challengeId = null,
  isEvent = 'challenge',
  handleClick,
  mutedState,
  setMutedState,
}) => {
  const videoRef = useRef(null); // Initialize videoRef as an array
  const videoRefMobile = useRef([]); // Initialize videoRef as an array

  const [isMuted, setIsMuted] = useState(true);
  const [isPlaying, setIsPlaying] = useState(isChallengePage);
  const [isVideoLoading, setIsVideoLoading] = useState(true);

  const toggleMute = () => {
    // if (videoRef.current) {
    // videoRef.current.muted = !videoRef.current.muted;
    // setIsMuted(videoRef.current.muted);
    setMutedState((prev) => !prev);
  };

  const togglePlayPause = () => {
    if (!isMobile) {
      if (videoRef.current) {
        if (isPlaying) {
          videoRef.current.pause();
        } else {
          videoRef.current.play();
        }
        setIsPlaying(!isPlaying);
      }
    } else {
      if (videoRefMobile.current[0]) {
        if (isPlaying) {
          videoRefMobile.current[0].pause();
        } else {
          videoRefMobile.current[0].play();
        }
        setIsPlaying(!isPlaying);
      }
    }
  };

  const handleMouseEnter = () => {
    if (!isChallengePage && videoRef.current) {
      videoRef.current.play();
      setIsPlaying(true);
    }
  };

  const handleMouseLeave = () => {
    if (!isChallengePage && videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
      setIsPlaying(false);
    }
  };
  useEffect(() => {
    if (!isMobile) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            video.play();
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.8 }
    );

    // Ensure videoRefMobile.current is an array before using .forEach
    videoRefMobile.current.forEach((video) => {
      if (video) observer.observe(video);
    });

    return () => {
      videoRefMobile.current.forEach((video) => {
        if (video) observer.unobserve(video);
      });
    };
  }, []);

  const handleVideoLoaded = () => {
    setIsVideoLoading(false);
  };

  return (
    <Box
      position="relative"
      width="100%"
      borderRadius="5px"
      overflow="hidden"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {/* {isVideoLoading && (
        <Skeleton
          variant="rectangular"
          width="100%"
          height="auto"
          animation="wave"
          sx={{ aspectRatio: '16/9', borderRadius: '5px', bgcolor: 'grey' }}
        />
      )} */}
      {isVideoLoading && (
        <Backdrop
          open={isVideoLoading}
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(0,0,0,.1)',
            zIndex: 10,
            display: 'flex', // Flexbox for centering
            justifyContent: 'center', // Horizontally center
            alignItems: 'center', // Vertically center
          }}
        >
          <CircularProgress
            sx={{ position: 'absolute', top: '50%' }}
            color="inherit"
          />
        </Backdrop>
      )}

      {isMobile ? (
        <video
          ref={(el) => (videoRefMobile.current[0] = el)} // Storing the video reference
          src={videoUrl}
          autoPlay={isChallengePage}
          muted={mutedState}
          onLoadedData={handleVideoLoaded}
          style={{
            width: '100%',
            borderRadius: '5px',
            display: isVideoLoading ? 'none' : 'block',
          }}
          id={challengeId}
          onClick={(e) => handleClick(e, isEvent)}
        />
      ) : (
        <video
          ref={videoRef}
          src={videoUrl}
          autoPlay={isChallengePage}
        onEnded={() => {
          if (videoRef.current) {
            videoRef.current.play();
          }
        }}
        muted={mutedState}
          onLoadedData={handleVideoLoaded}
          style={{
            width: '100%',
            borderRadius: '5px',
            display: isVideoLoading ? 'none' : 'block',
          }}
          id={challengeId}
          onClick={(e) => handleClick(e, isEvent)}
        />
      )}

      {/* Play/Pause Icon Button - Only shown on Challenge Page */}
      {!isVideoLoading && isChallengePage && (
        <IconButton
          onClick={togglePlayPause}
          sx={{
            position: 'absolute',
            bottom: 10,
            left: 10,
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
            color: 'white',
            '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.8)' },
          }}
        >
          {isPlaying ? <PauseIcon /> : <PlayArrowIcon />}
        </IconButton>
      )}

      {/* Mute/Unmute Icon Button - Always on the right */}
      {!isVideoLoading && (
        <IconButton
          onClick={toggleMute}
          sx={{
            position: 'absolute',
            zIndex: '999999',
            bottom: 10,
            right: 10,
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
            color: 'white',
            '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.8)' },
          }}
        >
          {mutedState ? <VolumeOffIcon /> : <VolumeUpIcon />}
        </IconButton>
      )}
    </Box>
  );
};

export default VideoPlayer;
